/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const CATEGORY_ADD = 'CATEGORY_ADD';
export const CATEGORY_BEGIN = 'CATEGORY_BEGIN';
export const CATEGORY_FAILURE = 'CATEGORY_FAILURE';
export const CATEGORY_CLEAR = 'CATEGORY_CLEAR';

export function fetchCategory(data) {
	return async dispatch => {
        dispatch(categoryBegin());
        await ApiService.getCategories(data)
			.then(
				result => {
                    let normalized = normalizeById(result.Data, 'idCategory');
                    dispatch(categoryAdd(normalized));
					return normalized;
				},
				error => {
                    dispatch(categoryError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}


export const categoryBegin = () => ({
    type: CATEGORY_BEGIN,
});

export const categoryAdd = data => ({
    type: CATEGORY_ADD,
	payload: { data }
})

export const categoryError = () => ({
    type: CATEGORY_FAILURE,
})

export const categoryClear = () =>({
    type: CATEGORY_CLEAR,
})

